import { useUpdateEffect } from 'ahooks';
import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import { useConfig } from '../hooks/useConfig';
import { formatStringValue } from './utils';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const TextSearch = /*#__PURE__*/forwardRef((props, ref) => {
  var _ref;
  const {
    locale: {
      SuperSearch: SuperSearchLocale
    }
  } = useConfig();
  const {
    defaultValue,
    value,
    placeholder,
    multiple,
    onSearch,
    baseClassName,
    toggleClearIcon
  } = props;
  const [inputFocus, setInputFocus] = useState(false);
  const [inputValue, setInputValue] = useState((_ref = value !== null && value !== void 0 ? value : defaultValue) !== null && _ref !== void 0 ? _ref : '');
  const inputRef = useRef(null);

  // 包装 onSearch
  const submit = v => {
    onSearch(v);
  };
  const focus = () => {
    var _inputRef$current;
    (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 || _inputRef$current.focus();
  };
  const blur = () => {
    var _inputRef$current2;
    (_inputRef$current2 = inputRef.current) === null || _inputRef$current2 === void 0 || _inputRef$current2.blur();
  };
  const clear = () => {
    setInputValue('');
    submit(undefined);
  };

  // 提供自定义的 ref
  useImperativeHandle(ref, () => ({
    focus,
    clear,
    blur
  }));
  useUpdateEffect(() => {
    if (value !== inputValue) {
      setInputValue(value !== null && value !== void 0 ? value : '');
    }
  }, [value]);
  useEffect(() => {
    toggleClearIcon(!!inputValue);
  }, [inputValue]);
  return /*#__PURE__*/_jsxs("div", {
    className: "".concat(baseClassName, "--search"),
    children: [/*#__PURE__*/_jsx("div", {
      "data-super-search-content": "1",
      className: "".concat(baseClassName, "--search--mirror"),
      style: {
        height: inputFocus ? 0 : 'max-content'
      },
      children: inputValue
    }), /*#__PURE__*/_jsx("input", {
      ref: inputRef,
      value: inputValue,
      placeholder: inputFocus ? multiple ? SuperSearchLocale.placeholder.empty.focus.multiple : SuperSearchLocale.placeholder.empty.focus.single : placeholder,
      onFocus: () => {
        setInputFocus(true);
      },
      onBlur: () => {
        setInputFocus(false);
      },
      onChange: e => {
        setInputValue(e.target.value);
      },
      onKeyDown: e => {
        switch (e.key) {
          case 'Enter':
            e.preventDefault();
            const v = formatStringValue(inputValue.trim());
            setInputValue(v);
            submit(v);
            blur();
            break;
          case 'Escape':
            blur();
            break;
          default:
            break;
        }
      }
    })]
  });
});
export default TextSearch;